module.exports = __webpack_public_path__ + "static/media/Scan 2.9150a322.jpeg";